module.exports = __webpack_public_path__ + "img/quote-icon.a1ffb42e.svg";